import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getCrewListSelector, getCrewSelector } from '../selectors'
import {
  ICrewMemberList,
  ICrewState,
  ICrewMember,
  ICrewLicensures,
  ICrewLicensuresOptions,
  ICrewLicensureValues,
} from '../store/crew.types'
import { CrewConstants } from '../store/crew.constants'
import { setCrewList } from '../store/crew.actions'
import { PCRConstants } from '../../pcr/store/pcr.constants'

export function* saveCrewLicensures() {
  const crewStateData: ICrewState = yield select(getCrewSelector)
  const crewListSelector: ICrewMemberList = yield select(getCrewListSelector)
  const { crewLicensuresOptions } = crewStateData
  try {
    const data: ICrewMemberList = []
    crewListSelector.forEach((crewObj: ICrewMember) => {
      let dataPushed = 0
      crewLicensuresOptions.forEach((crewLicensureObj: ICrewLicensuresOptions) => {
        if (crewObj.userId?.id === crewLicensureObj.userId) {
          const userLicensures: ICrewLicensures = {}
          crewLicensureObj.licensures?.forEach((licensureObj) => {
            if (licensureObj.certType) {
              const licensureValues: ICrewLicensureValues = {
                id: licensureObj.stateId,
                crewLevel: licensureObj.crewLevel,
                isCertType: true,
              }
              userLicensures[licensureObj.certType] = licensureValues
            } else if (licensureObj.state) {
              const licensureValues: ICrewLicensureValues = {
                id: licensureObj.stateId,
                type: licensureObj.stateType,
                isCertType: false,
              }
              userLicensures[licensureObj.state] = licensureValues
            }
          })
          dataPushed = 1
          data.push({ ...crewObj, licensures: userLicensures })
        }
      })
      if (dataPushed === 0) data.push({ ...crewObj })
    })
    yield put(setCrewList(data))
  } catch (e) {
    yield put(throwPcrException(`saveCrewLicensures() error: ${e}`))
  }
}

export function* saveCrewLicensuresSaga() {
  yield takeLatest(
    [PCRConstants.CREATE_PCR, CrewConstants.SET_CREW_LICENSURES_OPTIONS, CrewConstants.SET_NAME],
    saveCrewLicensures
  )
}
